import { ROLES, PRIO_WEIGHT, CREATOR, WORK_STATUS } from "./board.constants";
import {
  getAdaptiveDepartmentTodos,
  getDepartmentTransitionMeta,
} from "./board.engine";
import { daysLeft, parseSubtasks } from "./board.utils";

export const setWorkStatus = (card, newStatus, meta = {}) => ({
  ...card,
  workStatus: newStatus,
  blockedReason: newStatus === WORK_STATUS.BLOCKED ? meta.reason || "" : null,
  history: [
    ...(card.history || []),
    {
      ts: new Date().toISOString(),
      by: meta.by || CREATOR,
      action: `Status -> ${newStatus}`,
      meta,
    },
  ],
});

export const nextStage = (card) => {
  if (card.needsSpenglerei && card.role === "Werkstatt") {
    return "Spenglerei";
  }

  if (card.role === "Werkstatt" && card.workStatus === WORK_STATUS.DONE) {
    return "Fahrzeugaufbereitung";
  }

  if (card.needsSpenglerei && card.role === "Spenglerei") {
    return "Rechnung";
  }

  const idx = ROLES.indexOf(card.role);
  return ROLES[idx + 1] || null;
};

export const handoverCard = (card, actor) => {
  if (card.workStatus === WORK_STATUS.BLOCKED) return card;

  const nextRole = nextStage(card) || card.role;
  const transitionMeta = getDepartmentTransitionMeta(card, nextRole);
  const moved = nextRole !== card.role;

  return {
    ...card,
    role: nextRole,
    subs: moved
      ? parseSubtasks(getAdaptiveDepartmentTodos(card, nextRole))
      : card.subs || [],
    workStatus: moved ? WORK_STATUS.IN_WORK : WORK_STATUS.DONE,
    mediaLocked: transitionMeta?.lockMedia || false,
    history: [
      ...(card.history || []),
      {
        ts: new Date().toISOString(),
        by: actor,
        action: moved ? `Übergabe an ${nextRole}` : "Prozess abgeschlossen",
      },
    ],
  };
};

export const filterAndSortCards = (cards, ui) => {
  let list = [...(cards || [])];

  if (ROLES.includes(ui.activeView)) {
    list = list.filter((c) => c.role === ui.activeView);
  }

  if (ui.activeView === "Tagesboard") {
    list = list.filter((c) => {
      if (c.workStatus === WORK_STATUS.DONE) return false;
      const d = daysLeft(c.due);
      if (ui.dayMode === "today_overdue") return d !== null && d <= 0;
      if (ui.dayMode === "today") return d === 0;
      return true;
    });
  }

  if (ui.search) {
    const s = ui.search.toLowerCase();
    list = list.filter(
      (c) => {
        const vehicle = c.vehicleData || {};
        return [
          c.title,
          c.id,
          c.orderNumber,
          c.licensePlate,
          c.customerName,
          c.customerFirstName,
          c.customerLastName,
          c.customerEmail,
          c.caseType,
          c.role,
          c.responsibleLabel,
          c.assignedTech,
          c.managementNotes,
          c.externalReference,
          vehicle.brand,
          vehicle.model,
          vehicle.vin,
          vehicle.nationalCode,
          vehicle.mileage,
        ]
          .filter(Boolean)
          .some((value) => String(value).toLowerCase().includes(s));
      }
    );
  }

  if (ui.statusFilter) {
    list = list.filter((c) => c.workStatus === ui.statusFilter);
  }

  if (ui.prioFilter) {
    list = list.filter((c) => c.prio === ui.prioFilter);
  }

  if (ui.sortBy === "due_asc") {
    list.sort((a, b) => (a.due || "9999").localeCompare(b.due || "9999"));
  }

  if (ui.sortBy === "prio_desc") {
    list.sort(
      (a, b) => (PRIO_WEIGHT[b.prio] || 0) - (PRIO_WEIGHT[a.prio] || 0)
    );
  }

  if (ui.sortBy === "title_asc") {
    list.sort((a, b) => (a.title || "").localeCompare(b.title || ""));
  }

  return list;
};
